<template>	
	<div>
			<!-- <span v-if="bsData==1">-->
			<span v-if="bscheckedData">
				<b-row class="mb-3" v-if="businessData.seller_upload_kyc_verify==null || businessData.seller_upload_kyc_verify=='null'">
							<b-col lg="4" sm="12">
								<!-- {{JSON.stringify(businessData)}}
								{{businessData.length}}
								{{businessData}} -->
							</b-col>
						
						<b-col lg="4" sm="12">
							<small class="p-2">&nbsp; <!-- Step 1: --></small>
							<b-card>
								<h6><b-link class="mr-4" :href="'https://www.alluraa.com/media/kyc/'+businessData.seller_upload_kyc"  download="download" > <b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Download Agreement </b-link>
								<br /><small class="ml-4">(signed by Seller)</small> </h6>
							</b-card>
						</b-col>
							<b-col lg="4" sm="12" v-if="fileuploadsucess==''">
							<small class="p-2">&nbsp; <!-- Step 2: <span style="font-size: 12px;"> Upload documet with authorized signature!</span> --> </small>
							
								
									
									
									<b-form-group :state="businessState.business_logo" label-for="sa-dd" invalid-feedback="Please Upload Signed Agreement!" label-size="sm" >
										<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png,.pdf,.doc,.docx" size="sm" placeholder="Upload Signed Agreement" label-size="sm" id="sa-dd" :state="businessState.business_logo" @focusin="businessState.business_logo = null" ></b-form-file>
									</b-form-group>
										<b-button variant="dark" pill  @click="saveProfile()"><b-icon class="mr-2" icon="upload" aria-hidden="true"></b-icon>Upload a Verify Document</b-button>
									
							
							</b-col>
							<b-col lg="4" sm="12" v-else >
							<small class="p-2">&nbsp; <!-- Step 2:--> </small>
							<b-card>
								<h6><b-link class="mr-1" :href="'https://www.alluraa.com/media/kyc/'+fileuploadsucess"  download="download" > Agreement Copy <b-icon class="ml-1" icon="eye" aria-hidden="true"></b-icon> </b-link> <br />
								<small> (Signed by Alluraa and Seller)</small> </h6>
							</b-card>
						</b-col>
						
						
					</b-row>
					<b-row v-else>
						<b-col lg="4" sm="12">
								<!-- {{JSON.stringify(businessData)}}
								{{businessData.length}}
								{{businessData}} -->
							</b-col>
						<b-col lg="4" sm="12">
							<small class="p-2">&nbsp; <!-- Step 1: --></small>
							<b-card>
								<h6><b-link class="mr-1" :href="'https://www.alluraa.com/media/kyc/'+businessData.seller_upload_kyc"  download="download" > Agreement Copy <b-icon class="ml-2" icon="eye" aria-hidden="true"></b-icon></b-link><br/>
								<small>(signed by Seller)</small> 
								</h6>
							</b-card>
						</b-col>
						<b-col lg="4" sm="12" >
							<small class="p-2">&nbsp; <!-- Step 2:--> </small>
							<b-card>
								<h6><b-link class="mr-1" :href="'https://www.alluraa.com/media/kyc/'+businessData.seller_upload_kyc_verify"  download="download" > Agreement Copy <b-icon class="ml-1" icon="eye" aria-hidden="true"></b-icon> </b-link> <br />
								<small> (Signed by Alluraa and Seller)</small> </h6>
							</b-card>
						</b-col>
						
					</b-row>




					
				</span>
				<span v-else>
					<b-row >
						<b-col>
							No Agreement Uploaded!
						</b-col>
					</b-row>
				</span>
				
				
				
			</div>
	</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
export default {
  name: 'ProfileBusiness',
  components: {
  //"cart-variant": CartVariant,
  },
  props: {
  businessData: { type: Object },
   /* cartData: { type: Object  }, 
	cartTotalqty:Number,*/
  },
  mounted(){
 
  
  },
  computed: {
     bscheckedData() {
		var  bsDatares =false;
    //  return this.new_password.length > 3 ? true : false
		  if (typeof(this.businessData.seller_upload_kyc) == "undefined"){
			//this.bsData=0;
			bsDatares=false;
		}else{
			if(this.businessData.seller_upload_kyc=='' ||this.businessData.seller_upload_kyc==null || this.businessData.seller_upload_kyc=='null'){
			//this.bsData=0;
			bsDatares=false;
			}else{
			//this.bsData=1;
			bsDatares=true;
			}
		}
		return bsDatares;
    }
  },
  data() {
    return{
		recordUrl: this.$root.NEWAPIURL+'profileapi/load-business',
		//uploadBusUrl: this.$root.NEWAPIURL+'profileapi/upload_profilebusiness', 
		uploadBusUrl: this.$root.NEWAPIURL+'profileapi/upload_kycdocument_seller_verify', 
		uploadCSUrl: this.$root.NEWAPIURL+'profileapi/upload_profilecustomersupport', 
		editField : '',
		addOfficeaddress:0,
		business:{
				business_logo:'',
			},
		businessState:{
			business_logo:null,
			
		},
		shippingaddress:{},
		product_inf:{},
		thumbnailProps: { blank: false, width: 80, height: 80, class: 'm1' },
		editLogo:0,
		customerSupport:0,
		csContact:{
			cs_email:'',
			cs_phone:''
		},
		cscontactState:{
			cs_email:null,
			cs_phone:null
			
		},
		csContactError:{
			cs_email:null,
			cs_phone:'Please enter Phone number!',
			
		},
		bsData:1,
		fileuploadsucess:''
		
	}
  },
  methods:{
	inLodcard(){
			var self = this;			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var tmp = response.data.result;
					
					//console.log('Muygahs'+tmp);
					if(tmp!=null){
					self.business = Object.assign({}, tmp);
					}
					if(self.business.office_address!=''){
					self.addOfficeaddress=1;
					}
					if(self.business.business_logo!= null){
						self.editLogo=1;
					}
					if(tmp!=null){					
					self.csContact = Object.assign({}, tmp.csdetails);
					}
					
					
					//self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		
	},
	saveProfile(){
		//alert('len'+this.shippingaddress.firstname.length);
		// console.log("itIS seller:"+this.businessData.user_id);
		var valid = true;
		//console.log('dev'+this.product_inf.product_image_1);
		if (typeof(this.product_inf.product_image_1) == "undefined"){
			this.businessState.business_logo = false;
			valid = false;
		}else{
			this.businessState.business_logo = true;
		}
		
		

		

		if(valid){
			var self = this;
			
			
			let formData = new FormData();
			formData.append('imagefile1', this.product_inf.product_image_1);	
            formData.append('accesskey', this.$session.get('access_key'));
            formData.append('user_id', this.businessData.user_id);

            self.axios.post(self.uploadBusUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log("ddd"+response.data);
					//self.shippingaddressData = response.data.result.shippingaddressData;
					//self.showAddaddress=0;
					  self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
					});
					
					self.fileuploadsucess=response.data.result.seller_upload_kyc_verify;
					
					self.business={
						
						business_logo:'',
						
					};
					self.businessState={
						business_logo:null,
						
					};
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}else{
					alert(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		}
		

	}


    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">
.col-form-label-sm{
padding:0px;
margin:0px;}

</style>
